(() => {
  const STORAGE_KEY = 'hpm_pet_overlay_played_v1';

  function initHpmPetOverlay() {
    const overlay = document.getElementById('hpm-pet-overlay');
    if (!overlay) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const forcePreview = new URLSearchParams(window.location.search).get('hpmPetTest') === '1';

    if (!forcePreview) {
      try {
        if (sessionStorage.getItem(STORAGE_KEY) === '1') return;
      } catch (error) {
        // If sessionStorage is unavailable, allow the animation rather than blocking the page.
      }
    }

    const delay = 450;
    window.setTimeout(() => {
      if (!forcePreview) {
        try {
          sessionStorage.setItem(STORAGE_KEY, '1');
        } catch (error) {
          // If sessionStorage is unavailable, continue with the animation.
        }
      }

      overlay.hidden = false;
      requestAnimationFrame(() => overlay.classList.add('is-playing'));

      const dog = overlay.querySelector('.hpm-pet-overlay__dog');
      if (!dog) return;

      dog.addEventListener(
        'animationend',
        () => {
          overlay.classList.remove('is-playing');
          overlay.hidden = true;
        },
        { once: true }
      );
    }, delay);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHpmPetOverlay, { once: true });
  } else {
    initHpmPetOverlay();
  }
})();
